import { DecimalPipe } from "@angular/common";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "app/auth/auth.service";
import { DestinationPageType } from "components/eprescribe/eprescribe.component";
import {
  AlertController,
  LoadingController,
  ModalController,
  NavParams,
  Platform,
  ToastController,
} from "ionic-angular";
import { DropdownItem } from "models/order-management/dropdownItem";
import { OrderErrorResponse } from "models/order-management/errorResponse";
import { HistoryDetailSummary } from "models/order-management/historyDetailSummary";
import { Order } from "models/order-management/models";
import { OpenSearchResponse } from "models/order-management/openSearchResponse";
import { OrderResponse } from "models/order-management/orderResponse";
import { OrderSearchDateRange } from "models/order-management/orderSearchDateRange";
import { OrderSearchRequest } from "models/order-management/orderSearchRequest";
import { OrderSignatureRequest } from "models/order-management/orderSignatureRequest";
import { OrderTypeConfiguration } from "models/order-management/orderTypeConfiguration";
import { StatefulOrderResponse } from "models/order-management/statefullOrderResponse";
import CredentialedResource from "models/resource-management/credentialed-resource";
import * as moment from "moment-timezone";
import {
  getOrderTypeDisplayName,
  OrderTypeSubtype,
} from "pages/orders-entry-om/order-utils";
import { CareTeamsService } from "providers/care-teams-service/care-teams-service";
import { NavBarServiceProvider } from "providers/nav-bar-service/nav-bar-service";
import { OrderManagementDataService } from "providers/order-management-data-service/order-management-data-service";
import { ResourceManagementService } from "providers/resource-management/resource-management.service";
import { Subscription } from "rxjs";
import { of } from "rxjs/observable/of";
import { switchMap } from "rxjs/operators";
import { AccessControlService } from "../../../../app/access-control/access-control-service";
import { BasePage } from "../../../../pages/base-page";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { ConfigurationService } from "../../../../providers/configuration/configuration.service";
import { OrderDataService } from "../../../../providers/order-data-service/order-data-service";
import { StateManagementService } from "../../../../providers/state-management/state-management.service";
/**
 * Generated class for the ListCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

const DATE_RANGE_COLUMN = "startDate";
@Component({
  selector: "order-entry-om-card",
  templateUrl: "order-entry-om-card.html",
})
export class OrderEntryOmCard
  extends BasePage
  implements OnInit, OnDestroy, OnChanges
{
  @Input() patChartId: string;
  @Input() config;
  @Input() disabled: boolean = false;

  label: string;
  numOpenOrders = 0;
  segment = "newOrders"; //sets initial segment to 'New Orders'
  orderTypeOptions = [];
  categoryOptions = [];
  roleEnums = [];
  showOrderManagement = true;
  patientId: any;
  patientCareType: string = "";
  patientCareTypeSubscription: Subscription;
  searchForm: FormGroup;
  error: boolean = false;
  searchField = new FormControl("");
  credentialedResource: CredentialedResource;
  userDisplayName: string;
  type: string = "OE";

  // Filters
  orders: Array<StatefulOrderResponse> = [];
  locOrders: Array<StatefulOrderResponse> = null;
  orderTypeConfigurations: Array<OrderTypeConfiguration> = [];
  fromDate: any = null;
  toDate: any = null;
  orderSearchDetails: OrderSearchRequest = null;
  search: string = null;
  discontinuedOrdersEnabled: boolean = true;
  discontinuedDetails: boolean = true;

  totalPageCount: number = 1;
  currentPage: number = 0;
  pageSize: number = 100;
  sortColumn: string = "startDate";
  sortDirection: "asc" | "desc" = "desc";
  orderTemp = null;
  historyDetails: HistoryDetailSummary[] = [];

  orderData = [];
  orderTypeDropdownItems: Array<DropdownItem> = [];
  orderTypes: string;
  spinnerCounter = 0;
  spinner = null;

  teamName: string = "";
  teamId: number = 0;
  teamQbosId: number = 0;
  selectPrintOptions: any[];
  printOptions: any[] = [
    { displayName: "Print All", key: "print_all" },
    { displayName: "Print Filtered", key: "print_filtered" },
  ];

  prefilledData = null;
  signedStatus?: OrderSignatureRequest.SignedStatusEnum = null;

  shouldStopOrderCreation = false;
  showNoOrdersMsg = false;
  patientChartIdProviderPanel: number = 0;
  externalIdProviderPanel: number = 0;

  // Subscription functions
  featureToggleLoadedFn: Function;

  orderTypesWithHospiceCoverage = [];
  showEPrescribeIframe = false;
  destinationPage: DestinationPageType = "drug-list";

  @ViewChild("orderTypeDropdown") orderTypeDropdown;

  constructor(
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public dataService: AssessmentDataService,
    public decimalPipe: DecimalPipe,
    public plt: Platform,
    private alertCtrl: AlertController,
    public translatePipe: TranslateService,
    private http: HttpClient,
    private accessCntrl: AccessControlService,
    private configurationService: ConfigurationService,
    private orderService: OrderDataService,
    private toastCtrl: ToastController,
    private orderManagementDataService: OrderManagementDataService,
    private navBarService: NavBarServiceProvider,
    public loadingCtrl: LoadingController,
    private elementRef: ElementRef,
    private resourceManagementService: ResourceManagementService,
    private authSvc: AuthService,
    private fb: FormBuilder,
    private careTeamService: CareTeamsService,
    public stateData: StateManagementService
  ) {
    super(stateData);
    this.searchForm = this.fb.group({
      fromDate: this.fb.control(""),
      toDate: this.fb.control(""),
      type: this.fb.control(null),
    });
  }

  loadConfigurations() {
    this.label = "Current Orders";
  }

  fromDateHandler() {
    let fromDate = this.formatDate(this.fromDate);
    let toDate = this.formatDate(this.toDate);
    if (moment(toDate).isBefore(fromDate)) {
      this.fromDate = null;
      this.searchForm.get("fromDate").setValue("");
      this.toastError("From Date must be less than To Date.");
    }
  }

  formatDate(date) {
    if (date !== null) {
      return moment(date).format("YYYY-MM-DD");
    } else {
      return date;
    }
  }

  toastError(message: string, showCloseButton = false) {
    let toast = this.toastCtrl.create({
      message: message,
      showCloseButton: showCloseButton,
      duration: showCloseButton ? undefined : 6000,
      position: "below",
      cssClass: "error",
    });
    toast.present().then();
  }

  getOrderTypeConfigurations(): void {
    this.orderManagementDataService
      .getOrderTypes()
      .subscribe((orderTypeConfigurations) => {
        this.orderTypeConfigurations = orderTypeConfigurations;
        this.setOrderTypeList(this.orderTypeConfigurations);
      }, this.handleError("Could not get order type configurations."));
  }

  public setOrderTypeList(
    orderTypeConfigurations: Array<OrderTypeConfiguration>
  ): void {
    this.orderTypeDropdownItems = orderTypeConfigurations
      .filter(
        (orderTypeConfiguration) =>
          orderTypeConfiguration.orderType &&
          orderTypeConfiguration.orderTypeDisplayName &&
          (orderTypeConfiguration.isDisabled == false ||
            orderTypeConfiguration.isDisabled === undefined)
      )
      .sort(
        (config1, config2) =>
          (config1.orderTypeSort ? config1.orderTypeSort : Infinity) -
          (config2.orderTypeSort ? config2.orderTypeSort : Infinity)
      )
      .map((orderTypeConfiguration) => {
        return {
          label: orderTypeConfiguration.orderTypeDisplayName,
          value: orderTypeConfiguration.orderType,
        };
      });
  }

  handleError(defaultMessage: string, callback?: Function) {
    return (err: HttpErrorResponse) => {
      console.log(err.error);
      try {
        const errorResponse = err.error as OrderErrorResponse;
        const errorCode = err.status;
        const toast = this.toastCtrl.create({
          message: OrderErrorResponse.toMessage(errorResponse, errorCode),
          showCloseButton: true,
          position: "below",
          cssClass: "error",
        });
        toast.present();
      } catch (_parseError) {
        let toast = this.toastCtrl.create({
          message: defaultMessage,
          duration: 3000,
          position: "below",
          cssClass: "error",
        });
        toast.onDidDismiss(() => {
          // Do nothing
        });
        toast.present();
      }
      if (typeof callback === "function") {
        callback();
      }
    };
  }

  onChangeDatepicker(event: any, control: string) {
    if (event) {
      let value = event.target.value;
      let valueFormatted = moment(value, "MM/DD/YYYY", true);
      if (valueFormatted.isValid()) {
        switch (control) {
          case "fromDate":
            this.fromDate = new Date(valueFormatted);
            this.searchForm.get("fromDate").setValue(this.fromDate);
            this.fromDateHandler();
            break;
          case "toDate":
            this.toDate = new Date(valueFormatted);
            this.searchForm.get("toDate").setValue(this.toDate);
            this.toDateHandler();
            break;
        }
        this.error = false;
      } else {
        this.error = true;
      }
    }
  }

  toDateHandler() {
    let fromDate = this.formatDate(this.fromDate);
    let toDate = this.formatDate(this.toDate);
    if (moment(fromDate).isAfter(toDate)) {
      this.toDate = null;
      this.searchForm.get("toDate").setValue("");
      this.toastError("To Date must be greater than From Date.");
    }
  }

  loadData(): void {
    this.increaseSpinnerCount("Loading orders ...");
    this.orders = [];
    this.createSearchRequestBody();

    let details: OrderSearchRequest = {};
    details.patientChartId =
      this.externalIdProviderPanel > 0
        ? this.externalIdProviderPanel
        : Number(this.patChartId);
    details.from = this.currentPage * this.pageSize;
    details.size = this.pageSize;
    details.includeDiscontinued = true;

    this.orderManagementDataService
      .searchOrders(this.orderSearchDetails)
      .finally(() => this.decreaseSpinnerCount())
      .pipe(
        switchMap((searchResults) => {
          if (!searchResults.hits) {
            return this.orderManagementDataService.searchOrders(details);
          } else {
            if (searchResults && searchResults.hits) {
              this.showNoOrdersMsg = false;
              this.orders = searchResults.hits;
              this.orders = this.orders.map((s) => {
                s = {
                  ...s,
                  showMorePNotes: false,
                  showMoreDReason: false,
                  showMoreRnNotes: false,
                  showMoreHReason: false,
                  showMoreRGIP: false,
                  showMorePRNR: false,
                };
                return s;
              });
              this.totalPageCount = Math.ceil(
                searchResults.totalHits / this.pageSize
              );
            } else {
              this.orders = [];
            }
          }
          const emptyObject: OpenSearchResponse = {};
          return of(emptyObject);
        })
      )
      .subscribe((searchResults) => {
        this.showNoOrdersMsg = searchResults.totalHits == 0;
      }, this.handleError("Error loading orders."));
  }

  increaseSpinnerCount(message: string) {
    this.spinnerCounter++;
    if (this.spinnerCounter && this.spinner == null) {
      this.spinner = this.loadingCtrl.create({
        content: message,
      });
      this.spinner.present();
    }
  }
  decreaseSpinnerCount() {
    this.spinnerCounter--;
    if (this.spinnerCounter <= 0 && this.spinner) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }

  ngAfterViewInit() {}
  getUserInformation() {
    this.resourceManagementService
      .getCredentialedResourceByExternalId(this.authSvc.getUser().userId)
      .subscribe((provider) => {
        this.credentialedResource = provider;
        this.userDisplayName = provider.findDisplayName(new Date());
        this.getOrderTypeConfigurations();
      });
  }

  ngOnInit(): void {
    this.loadConfigurations();
    this.patientChartIdProviderPanel = this.navParams.data.patChartId;
    this.externalIdProviderPanel = Number(
      this.navParams.data.externalPatientChartId
    );
    this.loadData();
    this.getUserInformation();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.patientCareTypeSubscription) {
      this.patientCareTypeSubscription.unsubscribe();
    }
    this.navBarService.events.unsubscribe(
      "featureToggleLoaded",
      this.featureToggleLoadedFn
    );
  }

  createSearchRequestBody() {
    //TODO add signed orders filter
    let details: OrderSearchRequest = {};
    details.patientChartId =
      this.externalIdProviderPanel > 0
        ? this.externalIdProviderPanel
        : Number(this.patChartId);
    details.orderType = this.orderTypes;
    details.queryString = this.search === "" ? undefined : this.search;
    details.dateRange = this.getDateRange();
    details.from = this.currentPage * this.pageSize;
    details.size = this.pageSize;
    details.sortBy = {
      name: this.sortColumn,
      value: this.sortDirection,
    };
    details.includeDiscontinued = this.discontinuedOrdersEnabled;
    this.orderSearchDetails = details;
  }

  getItemsBySearchFilter() {
    this.currentPage = 0;
    this.loadData();
  }

  getDateRange(): OrderSearchDateRange | undefined {
    if (this.fromDate === null && this.toDate === null) {
      return undefined;
    } else {
      let dateRange: OrderSearchDateRange = {};

      if (this.fromDate != null) {
        dateRange.fromDate = this.formatDate(this.fromDate);
        dateRange.field = DATE_RANGE_COLUMN;
      }

      if (this.toDate != null) {
        dateRange.toDate = this.formatDate(this.toDate);
        dateRange.field = DATE_RANGE_COLUMN;
      }

      if (!moment(this.fromDate).isValid()) {
        delete dateRange.fromDate;
      }

      if (!moment(this.toDate).isValid()) {
        delete dateRange.toDate;
      }
      this.error = false;
      return dateRange;
    }
  }

  getCaretState(column: string) {
    if (this.sortColumn === column && this.sortDirection === "asc") {
      return "ios-arrow-up";
    }
    return "ios-arrow-down";
  }

  sortBy(selectedColumn: string) {
    if (this.sortColumn != selectedColumn) {
      this.sortColumn = selectedColumn;
      this.sortDirection = "desc";
    } else {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    }
    this.loadData();
  }

  orderIsDeclined(order: OrderResponse) {
    return Order.isVisitFrequencyDeclined(order);
  }

  getOrderTypeDisplayName(orderTypeSubtype: OrderTypeSubtype) {
    return getOrderTypeDisplayName(
      orderTypeSubtype,
      this.orderTypeConfigurations
    );
  }

  applyFiltersOS() {
    this.currentPage = 0;
    this.error = false;
    this.loadData();
  }
  clearFilters() {
    this.fromDate = undefined;
    this.toDate = undefined;
    this.orderTypes = undefined;
    this.orderTypeDropdown.clearModel();
    this.loadData();
  }

  onOrderTypeChange(event: DropdownItem) {
    if (event) {
      this.orderTypes = event.value;
    } else {
      this.orderTypes = null;
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    this.loadConfigurations();
    this.patientChartIdProviderPanel = this.navParams.data.patChartId;
    this.externalIdProviderPanel = Number(
      this.navParams.data.externalPatientChartId
    );
    this.loadData();
    this.getUserInformation();
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/order-entry-om/order-entry-om-card.ts